import React, {Component} from "react";
import Strings from "../../config/Strings";
import {BackButton} from "../../global/tiger-button/BackButton";
import {TigerSpinner} from "../../global/tiger-spinner/TigerSpinner";
import {withToast} from "../../util/ToastService";
import {GetDevicesForAccount, ReleaseFromDevice, GetDeviceIcon} from "./TigerboxSevice";
import GlobalConstants from "../../config/GlobalConstants";
import ErrorCodes from "../../config/ErrorCodes";
import {Badge, Card, Row} from "react-bootstrap";
import {TigerMessage} from "../../global/tiger-message/TigerMessage";

class Tigerboxes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            devices: [],
            showRemoveModal: false,
            deviceForRemoval: null
        };
    }

    async componentDidUpdate(prevProps) {
        window.scrollTo(0, 0);
        if (prevProps.accountId !== this.props.accountId) {
            await this.loadDevices();
        }
    }

    async componentDidMount() {
        await this.loadDevices();
    }

    async loadDevices() {
        this.setState({loading: true});
        if (this.props.accountId != null) {
            let response = await GetDevicesForAccount(this.props.accountId);

            if (!response.error) {
                const devicesRes = response.result._embedded?.devices ? response.result._embedded?.devices : [];

                this.setState({
                    devices: this.sortDevicesByOnboardingDate(devicesRes)
                });
            } else {
                this.props.addToast(Strings.TOAST_ERROR_FETCHING_DATA + ErrorCodes.CODE_DEVICE + " - " + response.message, {
                    autoDismiss: true,
                    appearance: 'error',
                    placement: 'bottom-center'
                });
                this.setState({
                    loading: false,
                    devices: []
                });
            }
        }
        this.setState({loading: false});

        //Window title
        document.title = "Meine tigerboxen :: tiger.media";
    }

    /**
     * Sorts the devices by the date they were last onboarded to the current account, newest first.
     * This mirrors the backend logic that grants premium access to the most recently onboarded boxes,
     * so boxes with premium access appear at the top. Devices without an onboarding date are listed last.
     */
    sortDevicesByOnboardingDate(devices) {
        return [...devices].sort((first, second) => {
            const firstDate = first.lastOnboardedDateCurrentAccount;
            const secondDate = second.lastOnboardedDateCurrentAccount;
            if (firstDate == null && secondDate == null) return 0;
            if (firstDate == null) return 1;
            if (secondDate == null) return -1;
            return secondDate.localeCompare(firstDate);
        });
    }

    showModal = (deviceId, index) => {
        this.setState({
            showRemoveModal: true,
            deviceForRemoval: {
                id: deviceId,
                index: index
            }
        });
    }

    openOverview(device) {
        this.props.history.push({
            pathname: "/" + GlobalConstants.APP_PATH + "tigerbox-details",
            state: {device: device}
        });
    }

    removeDevice = () => {
        ReleaseFromDevice(this.state.deviceForRemoval.id).then(res => {
            if (res.error === false) {
                // remove from state
                let deviceArray = this.state.devices;
                let ind = deviceArray.findIndex(d => d.id === this.state.deviceForRemoval.id);
                deviceArray.splice(ind, 1);

                this.setState({
                    devices: deviceArray
                }, () => {
                    this.props.addToast(Strings.TIGERBOXES_UNASSIGN_SUCCESS, {
                        autoDismiss: true,
                        appearance: 'success',
                        placement: 'bottom-center'
                    });
                });
            }
            else {
                this.props.addToast(Strings.TIGERBOXES_UNASSIGN_ERROR + res.message, {
                    autoDismiss: true,
                    appearance: 'error',
                    placement: 'bottom-center'
                });
            }
            this.setState({
                showRemoveModal: false,
                deviceForRemoval: null
            });
        });
    }

    closeView = () => {
        this.props.history.push({
            pathname: "/" + GlobalConstants.APP_PATH,
            state: this.state.profileLink
        })
    }

    render() {
        return (
            <div className="content-box devices-container">
                <BackButton onClick={() => this.closeView()}/>
                <div className="content-header" style={{color: '#fab900'}}>{Strings.TITLE_TIGERBOXES}</div>
                <div className="mb-4">
                    {!this.state.loading && this.state.devices.length !== 0 &&
                    <Row className="mx-0 devices-items-container">
                        {this.state.devices.map(device => {
                            return this.singleDevice(device)
                        })}
                    </Row>
                    }

                    {!this.state.loading && this.state.devices.length === 0 && (
                        <TigerMessage text={Strings.DEVICES_NOTHING_FOUND}/>
                    )}

                    {this.state.loading && <TigerSpinner/>}
                </div>
            </div>
        )
    }

    singleDevice(device) {
        return (
            <Card className="device mx-2" onClick={() => this.openOverview(device)}>
                <div style={{height: "23.6rem"}}>
                    <div style={{height: "100%"}}>
                        <img className="cover-image" src={GetDeviceIcon(device)} alt="cover" />
                    </div>
                </div>
                <Card.Body>
                    <Card.Title>{device.displayName}</Card.Title>
                    <Badge
                        className="premium-access-badge"
                        bg={device.premiumAccessAvailable ? "success" : "secondary"}
                    >
                        {device.premiumAccessAvailable
                            ? Strings.TIGERBOXES_PREMIUM_ACCESS_LABEL
                            : Strings.TIGERBOXES_NO_PREMIUM_ACCESS_LABEL}
                    </Badge>
                </Card.Body>
            </Card>
        );
    }
}

export default withToast(Tigerboxes);